import Vue from 'vue'
import VueRouter from 'vue-router'
import Registros from '../components/registros/Container'
import Configuracion from '../components/configuracion/Container'
import Usuarios from '../components/usuarios/Container'
import Paises from '../components/paises/Container'
import IPsConfianza from '../components/IPsConfianza/Container'
import IPsBloqueadas from '../components/IPsBloqueadas/Container'
import Login from '../components/login/LoginForm'
import store from '../store'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'home',
      meta:{
          title: 'Registros',
          requiresAuth: true
      },
      component: Registros
    },
    {
      path: '/configuracion',
      name: 'configuracion',
      meta:{
          title: 'Configuración',
          requiresAuth: true
      },
      component: Configuracion
    },
    {
      path: '/usuarios',
      name: 'usuarios',
      meta:{
          title: 'Usuarios',
          requiresAuth: true
      },
      component: Usuarios
    },
    {
      path: '/paises',
      name: 'paises',
      meta:{
          title: 'Países',
          requiresAuth: true
      },
      component: Paises
    },
    {
      path: '/ipsConfianza',
      name: 'ipsConfianza',
      meta:{
          title: 'IPs de confianza',
          requiresAuth: true
      },
      component: IPsConfianza
    },
    {
      path: '/ipsBloqueadas',
      name: 'ipsBloqueadas',
      meta:{
          title: 'IPs bloqueadas',
          requiresAuth: true
      },
      component: IPsBloqueadas
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      component: {
          template: '<div>404 Página no encontrada</div>'
      }
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(to.matched[0].path);
  if(to.matched[0].path === '*'){ // La ruta no existe
    if (!store.state.login.isAuth) { // No está autenticado
      next({
        name: 'login'
      });
    }else{
      next({
        name: 'home'
      });
    }
  }else{
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // Esta ruta requiere autenticación, verificamos si está logueado
      // si no, lo redirigimos a la página de login.
      if (!store.state.login.isAuth) {
        next({
          name: 'login'
        });
      } else {
        next(); // Este next deja pasar al usuario a la ruta que estaba solicitando
      }
    } else {
      //console.log(to.name+' === login && '+store.state.login.isAuth);
      if(to.name === 'login' && store.state.login.isAuth){
        next({
          name: 'home'
        });
      }else{
        next(); // make sure to always call next()!
      }
    }
  }
});

export default router
